var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        {
          staticClass: "temporaryHeight main-container",
          attrs: { id: "main-container" }
        },
        [
          _vm.pageShow
            ? _c(
                "div",
                { class: _vm.posterClass, attrs: { id: "publicityPage" } },
                [
                  _c("img", {
                    staticClass: "bgimg",
                    attrs: { src: _vm.posterImage, alt: "" }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "btn-join", on: { click: _vm.join } },
                    [_vm._v(_vm._s(_vm.btnTitle))]
                  ),
                  _vm._v(" "),
                  _c("div", { attrs: { id: "qrcode" } }),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      model: {
                        value: _vm.show,
                        callback: function($$v) {
                          _vm.show = $$v
                        },
                        expression: "show"
                      }
                    },
                    [
                      _c("img", {
                        staticClass: "bg",
                        attrs: {
                          src: require("../assets/img/fenxiao/haibao.jpg"),
                          alt: ""
                        }
                      })
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isDistribution
                    ? _c("div", { staticClass: "invitationCode" }, [
                        _c("div", [
                          _vm._v(
                            "\n                        我的邀请码\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _c("span", { attrs: { id: "spanId" } }, [
                            _vm._v(_vm._s(_vm.accountInvitationCode))
                          ]),
                          _vm._v(" "),
                          _c("span", { on: { click: _vm.copyText } }, [
                            _vm._v("点我复制")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "van-popup",
                    {
                      staticClass: "shadow",
                      model: {
                        value: _vm.shadowShow,
                        callback: function($$v) {
                          _vm.shadowShow = $$v
                        },
                        expression: "shadowShow"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.shadowShow,
                              expression: "shadowShow"
                            }
                          ],
                          staticClass: "shadow"
                        },
                        [
                          _c("img", {
                            staticClass: "shadowPicZx",
                            attrs: { src: _vm.shadowPicZx, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "shadowPicZxText",
                            attrs: { src: _vm.shadowPicZxText, alt: "" }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "shadowBtn" }, [
                            _c(
                              "div",
                              [
                                _c(
                                  "van-button",
                                  {
                                    staticClass: "btnColor1",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.makePic }
                                  },
                                  [_vm._v("生成海报")]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "van-button",
                                  {
                                    staticClass: "btnColor2",
                                    attrs: { type: "primary" },
                                    on: { click: _vm.cancelShadow }
                                  },
                                  [_vm._v("取消")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }